import { NuqsAdapter } from 'nuqs/adapters/next/pages';
import React, { type PropsWithChildren } from 'react';

const NuqsProvider: React.FC<PropsWithChildren> = ({ children }) => <NuqsAdapter>{children}</NuqsAdapter>;

export default NuqsProvider;
